<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div class="vx-card p-5" :style="isSmallerScreen ? '' : `height: 75vh`">
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="keyword"
            @keyup="search"
            placeholder="Search..."
          />
          <div class="table-container">
            <vs-button @click="addPolygon" class="mr-2 mt-2 btn-custom"
              >Add Geofence</vs-button
            >
            <h3 class="sidebar-title">Geofence List</h3>
            <table class="sidebar-table">
              <thead>
                <tr>
                  <th style="min-width: 15px">&nbsp;</th>
                  <th>Name</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody v-if="data.length > 0">
                <tr v-for="(item, index) in data" :key="index">
                  <td>
                    <vs-checkbox
                      icon-pack="feather"
                      icon="icon-map-pin"
                      color="rgb(38, 187, 174)"
                      v-model="selected"
                      :vs-value="item.id"
                      @click="check(item, $event)"
                    ></vs-checkbox>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>
                    <vs-dropdown vs-trigger-click>
                      <vs-button
                        radius
                        color="dark"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-settings"
                      ></vs-button>

                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="edit(item.id)"
                          >Edit</vs-dropdown-item
                        >
                        <vs-dropdown-item @click="del(item.id)"
                          >Delete</vs-dropdown-item
                        >
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    v-if="loading"
                    colspan="4"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    <vs-icon icon-pack="feather" icon="icon-loader"></vs-icon>
                    Loading....
                  </td>
                  <td
                    v-else
                    colspan="4"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    No Data Available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <vs-pagination
            style="margin-top: 20px"
            color="rgb(38, 187, 174)"
            :total="n_page"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full">
        <div
          class="vx-card p-3"
          :style="isSmallerScreen ? `height: 82vh` : `height: 75vh`"
        >
          <l-map
            id="map"
            ref="map"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            style="min-height: 100px"
          >
            <l-control-polyline-measure
              :options="{ showUnitControl: false }"
              position="topleft"
            />
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
            <l-polygon
              v-for="item in polygons"
              :key="item.id"
              :color="item.color"
              :fillColor="item.color"
              :lat-lngs="item.latlngs"
              :visible="item.visible"
            ></l-polygon>
          </l-map>
        </div>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        style="z-index: 51999"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                label="Geofence Name"
                class="w-full"
                v-model="input.name"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Type</label>
              <v-select
                :options="typeList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.type"
              />
            </div>
          </div>
          <div class="vx-row mb-3" v-if="actor.privilege < 4">
            <div class="vx-col sm:w-3/4 w-full required">
              <label class="vs-input--label">User</label>
              <v-select
                @search="searchUser"
                :disabled="userSelect || actor.privilege >= 4"
                :options="userList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.user"
              />
            </div>
            <div class="vx-col sm:w-1/4 w-full" style="padding-top: 2px">
              <vs-button
                v-if="!userSelect && actor.privilege < 4"
                class="mr-3 mt-5"
                color="warning"
                style="width: 100%"
                @click="selectUser"
                >Select</vs-button
              >
              <vs-button
                v-else
                class="mr-3 mt-5"
                :disabled="actor.privilege >= 4"
                color="danger"
                style="width: 100%"
                @click="changeUser"
                >Change</vs-button
              >
            </div>
          </div>
          <vs-divider v-if="actor.privilege < 4">
            Select User to Add Vehicle
          </vs-divider>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-3/4 w-full">
              <label class="vs-input--label">Vehicle</label>
              <v-select
                @search="searchVehicle"
                :disabled="!userSelect && actor.privilege < 4"
                :clearable="false"
                :options="vehicleList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.vehicle"
              />
            </div>
            <div class="vx-col sm:w-1/4 w-full" style="padding-top: 2px">
              <vs-button
                class="mr-3 mt-5"
                :disabled="!userSelect && actor.privilege < 4"
                color="success"
                style="width: 100%"
                @click="addVehicle"
                >Add</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full required">
              <label class="vs-input--label">Vehicle List</label>
              <div class="table-container">
                <table class="geo-table">
                  <thead>
                    <tr>
                      <th>Imei</th>
                      <th>Device Name</th>
                      <th>Plate</th>
                      <th>#</th>
                    </tr>
                  </thead>
                  <tbody v-if="selectedVehicle.length > 0">
                    <tr v-for="(item, index) in selectedVehicle" :key="index">
                      <td>{{ item.imei }}</td>
                      <td>{{ item.device_name }}</td>
                      <td>{{ item.plate }}</td>
                      <td>
                        <a href="javascript:;" @click="removeVehicle(index)"
                          >Remove</a
                        >
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" style="text-align: center">No Data</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
            </div>
          </div>
        </template>
        <vs-popup title="Inner popup" :active.sync="showPopup2">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </vs-popup>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LTooltip,
  LControlLayers
} from 'vue2-leaflet'
import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import vSelect from 'vue-select'
import 'leaflet-draw'

import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  components: {
    vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LTooltip,
    LControlLayers,
    LControlPolylineMeasure
  },

  data() {
    return {
      data: [],
      actor: {},
      token: '',
      tileProviders: [
        {
          name: 'Google Street',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 13
      },

      mapOptions: {
        minZoom: 2,
        zoomSnap: 0.5
      },

      vehicleList: [],
      userList: [],
      typeList: [
        { value: 0, label: 'IN' },
        { value: 1, label: 'OUT' }
      ],

      selectedVehicle: [],

      input: {
        user: '',
        name: '',
        vehicle: '',
        lat: '',
        lon: '',
        type: '',
        geom: ''
      },

      tempId: '',
      userSelect: false,

      action: '',
      showPopup: false,
      popupTitle: '',

      selected: [],

      page: 1,
      per_page: 7,
      row_total: 0,
      keyword: '',
      timer: null,
      loading: true,

      polygons: [],
      markers: [],

      notify: 'Server Error',
      showPopup2: false
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    isWider() {
      return this.$store.state.windowWidth >= 1440
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    isWider() {
      this.initTable()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data

        if (this.actor.privilege >= 4)
          this.input.user = { value: this.actor.id, label: this.actor.username }
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.initTable()
  },

  mounted() {
    this.$nextTick(() => {
      const map = this.$refs.map.mapObject
      const editableLayers = new L.FeatureGroup().addTo(map)
      const drawControl = new L.Control.Draw({
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            drawError: {
              color: 'red', // Color the shape will turn when intersects
              message: "<strong>Oh snap!<strong> you can't draw that!" // Message that will show when intersect
            },
            shapeOptions: {
              color: 'green'
            }
          },
          // disable toolbar item by setting it to false
          polyline: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false
        }
      })
      map.addControl(drawControl)
      map.on(L.Draw.Event.CREATED, (e) => {
        // const type = e.layerType;
        const layer = e.layer

        this.input.name = ''
        this.selectedVehicle = []
        this.input.vehicle = ''
        this.input.type = ''
        this.userSelect = false
        this.input.user = ''

        if (this.actor.privilege < 4) this.input.user = ''
        this.input.lat = layer._bounds._southWest.lat
        this.input.lon = layer._bounds._southWest.lng
        this.input.geom = this.polygonToGeom(layer._latlngs[0])

        this.action = 'add'
        this.popupTitle = 'Add Geofence'
        this.showPopup = true
      })
    })
  },

  methods: {
    addPolygon() {
      const map = this.$refs.map.mapObject
      const polygon = new L.Draw.Polygon(map)
      polygon.enable()
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    searchVehicle(search) {
      if (search.length >= 3) {
        this.$http
          .get(
            `${
              this.$api.endpoint
            }/tracking/search?type=vehicle&keyword=${search}&user=${
              this.input.user ? this.input.user.value : ''
            }`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.vehicleList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.vehicleList = []
      }
    },

    searchUser(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/general?search=${search}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.userList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.userList = []
      }
    },

    selectUser() {
      if (this.input.user === '') {
        this.$vs.notify({
          title: 'Sorry',
          text: 'user is required',
          color: 'danger',
          position: 'top-right'
        })
      } else this.userSelect = true
    },

    changeUser() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Change User?`,
        text: 'All selected vehicle will be remove ?',
        accept: () => {
          this.userSelect = false
          this.selectedVehicle = []
        }
      })
    },

    addVehicle() {
      if (this.input.vehicle !== '') {
        let x = {
          imei: this.input.vehicle.imei,
          device_name: this.input.vehicle.device_name,
          plate: this.input.vehicle.plate
        }

        let key = -1
        this.selectedVehicle.map((item, index) => {
          if (x.imei === item.imei) key = index
        })

        if (key !== -1) {
          this.$vs.notify({
            title: 'Sorry',
            text: 'Vehicle Already Selected',
            color: 'danger',
            position: 'top-right'
          })
        } else {
          this.selectedVehicle.push(x)
          this.vehicleList = []
          this.input.vehicle = ''
        }
      }
    },

    removeVehicle(index) {
      this.selectedVehicle.splice(index, 1)
    },

    edit(id) {
      this.tempId = id
      this.action = 'edit'
      this.popupTitle = 'Edit Geofence'

      this.$http
        .get(`${this.$api.endpoint}/zone/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.input.user = { value: data.user_id, label: data.username }
          ;(this.input.name = data.name), (this.input.lon = data.lon)
          this.input.lat = data.lat
          this.input.geom = data.geom
          this.input.type = this.typeList.find((item) => {
            return item.value === data.type
          })

          if (data.user) {
            this.input.user = { value: data.user.id, label: data.user.username }
          }

          this.userSelect = true

          this.input.vehicle = ''
          this.selectedVehicle = data.vehicle

          this.showPopup = true
          // this.userList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Geofence`,
        text: 'Are you sure want to Delete this Geofence ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/zone/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let imei = []
      this.selectedVehicle.map((item) => {
        imei.push(parseInt(item.imei))
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/zone/add`
          : `${this.$api.endpoint}/zone/update/${this.tempId}`

      this.$http
        .post(
          url,
          {
            imei: imei.length > 0 ? JSON.stringify(imei) : '',
            name: this.input.name,
            type: this.input.type ? this.input.type.value : '',
            geom: this.input.geom,
            lon: this.input.lon,
            lat: this.input.lat
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    check(item, event) {
      let visible = event.target.checked
      let key = -1

      this.polygons.map((data, index) => {
        if (data.id === item.id) key = index
      })

      if (key !== -1) {
        if (visible) {
          this.map.center = this.polygons[key].center
          // this.map.zoom = 10
        }
        this.polygons[key].visible = visible
      }

      // if(this.target.checked) {

      // } else {

      // }
    },

    initTable() {
      if (!this.isWider) this.per_page = 5
      else this.per_page = 10
      this.$http
        .get(
          `${this.$api.endpoint}/zone/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false

          // this.polygons = []
          // this.markers = []

          this.data.map((item) => {
            let key = -1
            let latlngs = this.geomToPolygon(item.geom)

            this.polygons.map((i, index) => {
              if (i.id === item.id) key = index
            })

            let color = item.type === 0 ? 'red' : 'green'

            if (key === -1) {
              this.polygons.push({
                id: item.id,
                name: item.name,
                latlngs: latlngs,
                center: L.latLng(item.lat, item.lon),
                visible: false,
                color: color
              })
            }
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    polygonToGeom(polygon) {
      let lonlat = ''
      polygon.map((item, index) => {
        // if(index > 0) lonlat += ', '
        if (index === 0)
          lonlat += `${item.lng} ${item.lat}, ${item.lng} ${item.lat}`
        else lonlat += `, ${item.lng} ${item.lat}`
      })

      lonlat += `, ${polygon[0].lng} ${polygon[0].lat}`

      return `POLYGON ((${lonlat}))`
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
